import React, { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateTheme } from '@components/settings/actions';
import { FormControl, FormControlLabel, Progress, Radio, RadioGroup, Typography } from '@mui';
import VisuallyHiddenLegend from '@shared/visually-hidden-legend';
import UnstyledHeading from '@shared/unstyled-heading';
import CustomizedDialog from '@shared/dialogs/dialog';
import './settings.scss';

const Theme = () => {
  const { global: { theme, available_themes: availableThemes } } = useSelector(state => state.config);
  const dispatch = useDispatch();
  const [applying, setApplying] = useState(false);

  const onChange = event => {
    setApplying(true);
    // On success updateTheme() reloads the page - nothing to do here. On failure it
    // re-throws (after showing the error Snackbar) so this can hide the overlay.
    dispatch(updateTheme(event.target.value)).catch(() => setApplying(false));
  };

  return (
    <div styleName="settings-form-container">
      <div styleName="title">
        <UnstyledHeading rank={2}>
          <div styleName="text">Theme</div>
        </UnstyledHeading>
      </div>
      <div styleName="hint">
        Switch between the available color and style themes.
      </div>
      <div styleName="form">
        <FormControl component="fieldset">
          <VisuallyHiddenLegend>Theme</VisuallyHiddenLegend>
          <RadioGroup aria-label="theme" name="theme" value={theme} onChange={onChange}>
            {availableThemes.map(({ value, label }) => (
              <FormControlLabel
                key={value}
                value={value}
                control={<Radio color="primary" />}
                label={label}
                disabled={applying}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </div>
      {applying && (
        <CustomizedDialog title="Applying theme" maxWidth="22rem">
          <div styleName="theme-applying">
            <Progress size={48} />
            <div role="status" aria-live="polite">
              <Typography>Applying your new theme. The page will reload automatically…</Typography>
            </div>
          </div>
        </CustomizedDialog>
      )}
    </div>
  );
};

export default memo(Theme);
